module.exports = __webpack_public_path__ + "img/cloud-and-arrow-up_fill.5d2e6be6.svg";